//GLOVES IS DONE

let Gloves= {
    None:{
        Name: "None",
        Stats:[0,0,0,0,0]
    },
    Muscle:{
        Name: "Muscle",
        Stats:[2,0,0,-2,0]
    },
    Turbo:{
        Name: "Turbo",
        Stats:[-2,2,0,0,0]
    },
    Cannon:{
        Name: "Cannon",
        Stats:[0,-2,2,0,0]
    },
    Chain:{
        Name: "Chain",
        Stats:[0,0,-2,2,0]
    },
    Trick:{
        Name: "Trick",
        Stats:[0,-2,0,0,2]
    },
    Bushido:{
        Name: "Bushido",
        Stats:[-1,-1,-1,-1,4]
    },
    Knight:{
        Name: "Knight",
        Stats:[+2,+1,+1,-2,-2]
    },
    Shellfish:{
        Name: "Shellfish",
        Stats:[+1,+2,-2,-2,+1]
    }
};

export default Gloves